import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import {
  fetchServiceTxnForms,
  fetchServiceTxnForm,
  updateServiceTxnForm,
  clearServiceTxnForm,
  fetchServiceTxnsCount,
  clearServiceTxnsCount,
  fetchServiceTxnsLatestSeq,
  clearServiceTxnsLatestSeq,
} from '../../actions/remote_api'
import ServiceFormPagerContainer from './ServiceFormPager.container'
import { isExtraCharged } from '../../services/serviceTxn'
import { createDateRange } from '../../utils/dateUtils'

class ServiceFormAPI extends React.Component {
  isLoadServiceTxn = false
  state = {
    currentPage: undefined,
    totalPage: undefined,
    totalCount: undefined,
    dateValue: moment(),
    searchArchived: false,
  }

  componentDidMount() {
    this.clearServiceTxnForm()

    // Initialize searchArchived from props if provided
    const initialSearchArchived = this.props.initialSearchArchived || false

    if (this.props.loadServiceTxn) {
      this.isLoadServiceTxn = true
      // First fetch the service transaction by _id to get its seq
      this.fetchServiceTxnById(this.props.loadServiceTxn._id, () => {
        this.setState(
          {
            dateValue: moment(this.props.loadServiceTxn.serviceDateTime),
            searchArchived: initialSearchArchived,
          },
          this.fetchServiceTxnForms,
        )
      }, initialSearchArchived)
    } else {
      this.setState(
        {
          searchArchived: initialSearchArchived,
        },
        this.fetchServiceTxnForms,
      )
    }
  }

  fetchServiceTxnById = (id, callback, searchArchived = false) => {
    if (!id) return
    // Store callback for when the transaction is loaded
    this.pendingCallback = callback
    // Fetch by ID - result will be handled in componentWillReceiveProps
    // Include source parameter if searching archived data
    const query = searchArchived ? { source: 'archived' } : undefined
    this.props.fetchServiceTxnForm(id, { query })
  }

  fetchServiceTxnBySeq = (seq) => {
    if (!seq) return
    this.fetchServiceTxn(seq)
  }

  getCurrentPage = (props) => {
    if (props.latestSeq <= 0) return undefined

    // Only use targetSeq or loadServiceTxn.seq for initial load
    if (this.isLoadServiceTxn) {
      return this.targetSeq || _.get(props, 'loadServiceTxn.seq', 1)
    }

    // Otherwise, use current page if it exists, or default to 1
    return this.state.currentPage || 1
  }

  componentWillReceiveProps(nextProps) {
    // Handle when single transaction is loaded by ID
    if (
      nextProps.serviceTxnById &&
      !this.props.serviceTxnById &&
      this.pendingCallback
    ) {
      // Extract seq from the loaded transaction
      this.targetSeq = nextProps.serviceTxnById.seq
      const callback = this.pendingCallback
      this.pendingCallback = null
      if (callback) callback()
      return
    }

    // Handle latest seq changes (for pagination)
    if (nextProps.latestSeq !== this.props.latestSeq) {
      let newCurrentPage = this.getCurrentPage(nextProps)

      // Reset to page 1 if the new total page count is smaller than current page
      if (newCurrentPage > nextProps.latestSeq && nextProps.latestSeq > 0) {
        newCurrentPage = 1
      }

      this.setState(
        {
          currentPage: newCurrentPage,
          totalPage: nextProps.latestSeq,
        },
        () => {
          if (this.state.currentPage > 0)
            this.fetchServiceTxn(this.state.currentPage)
          else this.clearServiceTxnForm()
        },
      )
    }

    // Handle total count changes (for display)
    if (nextProps.count !== this.props.count) {
      this.setState({
        totalCount: nextProps.count,
      })
    }
  }

  clearServiceTxnForm = () => {
    this.props.clearServiceTxnForm('list')
    this.props.clearServiceTxnForm('single')
    this.props.clearServiceTxnsCount()
    this.props.clearServiceTxnsLatestSeq()
  }

  fetchServiceTxnForms() {
    this.props.fetchServiceTxnsLatestSeq(this.createQuery())
    this.props.fetchServiceTxnsCount(this.createQuery())
  }

  fetchServiceTxn(seq = 1) {
    this.setState(
      {
        currentPage: seq,
      },
      () => {
        this.props.fetchServiceTxnForms({
          ...this.createQuery(seq),
          sort: 'seq',
          order: 'asc',
          seq,
        })
      },
    )
  }

  createQuery = () => {
    // Use timezone-aware date range
    const dateRange = createDateRange(this.state.dateValue)

    const query = {
      needWorkSheet: true,
      serviceDateTime_gte: dateRange.start,
      serviceDateTime_lte: dateRange.end,
    }

    // Add source parameter for archived data search
    if (this.state.searchArchived) {
      query.source = 'archived'
    }

    return query
  }

  handleDateChange = (dateValue) => {
    // this callback always happens after initialized which could means it load service txn from router state
    // but this prevent loading from router state twice
    this.isLoadServiceTxn = false
    if (!this.state.dateValue.isSame(dateValue, 'day')) {
      this.clearServiceTxnForm()
      this.setState(
        (state) => ({
          ...state,
          dateValue,
        }),
        this.fetchServiceTxnForms,
      )
    }
  }

  handleSearchArchivedChange = (searchArchived) => {
    this.clearServiceTxnForm()
    this.setState(
      {
        searchArchived,
      },
      this.fetchServiceTxnForms,
    )
  }

  handleUpdateServiceTxnForm = (serviceTxn, option) => {
    serviceTxn.isExtraCharged = isExtraCharged(serviceTxn)
    this.props.updateServiceTxnForm(serviceTxn, option)
  }

  render() {
    return (
      <ServiceFormPagerContainer
        dateValue={this.state.dateValue}
        onDateChange={this.handleDateChange}
        searchArchived={this.state.searchArchived}
        onSearchArchivedChange={this.handleSearchArchivedChange}
        updateServiceTxnForm={this.handleUpdateServiceTxnForm}
        serviceTxn={this.props.serviceTxn}
        currentPage={this.state.currentPage}
        totalPage={this.state.totalPage}
        totalCount={this.state.totalCount}
        fetchServiceTxnBySeq={this.fetchServiceTxnBySeq}
        jwt={this.props.jwt}
        auth={this.props.auth}
      />
    )
  }
}

export default connect(
  ({ fetch: { serviceTxnForm, serviceTxnsCount, serviceTxnsLatestSeq }, auth }) => ({
    serviceTxn: _.get(serviceTxnForm, 'list.0', undefined),
    serviceTxnById: _.get(serviceTxnForm, 'single', undefined),
    latestSeq: _.get(serviceTxnsLatestSeq, 'single.count', 0),
    count: _.get(serviceTxnsCount, 'single.count', 0),
    jwt: _.get(auth, 'jwt', undefined),
    auth,
  }),
  {
    fetchServiceTxnForms,
    fetchServiceTxnForm,
    updateServiceTxnForm,
    clearServiceTxnForm,
    fetchServiceTxnsCount,
    clearServiceTxnsCount,
    fetchServiceTxnsLatestSeq,
    clearServiceTxnsLatestSeq,
  },
)(ServiceFormAPI)
